import { createSlice } from "@reduxjs/toolkit";

export const INITIAL_STATE = {
  activeProposals: {},
  contracts: {},
  miscAnalyses: {},
  trackedOpportunities: {},
  workspaceStats: {},
};

export const dashboardSlice = createSlice({
  name: "dashboard",
  initialState: INITIAL_STATE,
  reducers: {
    resetState: () => INITIAL_STATE,
    setActivePropopsals: (state, { payload }) => {
      state.activeProposals = payload ?? {};
    },
    setContracts: (state, { payload }) => {
      state.contracts = payload ?? {};
    },
    setMiscAnalyses: (state, { payload }) => {
      state.miscAnalyses = payload ?? {};
    },
    setTrackedOpportunities: (state, { payload }) => {
      state.trackedOpportunities = payload ?? {};
    },
    setWorkspaceStats: (state, { payload }) => {
      state.workspaceStats = payload ?? {};
    },
  },
});

export const {
  setActivePropopsals,
  setContracts,
  setMiscAnalyses,
  setTrackedOpportunities,
  setWorkspaceStats,
} = dashboardSlice.actions;

export default dashboardSlice.reducer;
